import React from 'react';
import { CONTEXT_TYPES, VIEW_MODES } from '../constants';
import Conversations from '.';
import './style.scss';
import { useParams } from 'react-router-dom';


const ConversationsContainer = () => {
  const { conversationId } = useParams();

  return (
    <div className='k-chat-app-container'>
      <Conversations
        style={{marginTop:'60px'}}
        contextType={CONTEXT_TYPES.CONTAINER}
        viewMode={VIEW_MODES.WORKSPACE}
        conversationId={conversationId} // Pass conversationId from URL params
        // kxUser={kxUser}
      />
    </div>
  );
};

export default ConversationsContainer;
